import {
  reactSelectInlineError,
  reactSelectErrorStyles,
  SelectContainer,
  Icon,
  getTranslatedText,
  BackgroundIcon
} from '@nile/components';
import { GET_CLIENTS } from '@nile/graphql';
import { AccountClient, GET_ALL_TECH_GROUP } from '@nile/graphql';
import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator,
  DropdownArrow
} from '@nile/mangifera/src/Pebbles/select';
import { SVGIcon } from '@superops/super-icons';
import { Avatar, Spinner } from '@superops/ui-design-system';
import React, { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import Select from 'react-select';
import { cloneDeep } from 'lodash';
import envConfig from '@nile/home/src/Config/env';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

const SelectWrapper = styled.div`
  .container > div {
    border: none !important;
  }
  .Polaris-Avatar__Image {
    height: 20px;
    width: 20px;
    background: #d86bde !important;
  }
  .Polaris-Avatar--hasImage {
    background: #d86bde !important;
  }
  .container {
    margin: 0px 10px;
    width: 100%;
  }
`;

function TechGroupSelect(props) {
  const {
    intl,
    updateField,
    property,
    value,
    selectedValue,
    defaultValue,
    errors,
    icon,
    fetchBefore,
    conditions,
    isClearable,
    showLabel,
    disabled,
    clientsToFilter,
    hideIcon
  } = props;
  const [options, setoptions] = useState([]);
  const [error, setErrors] = useState('');

  const [getClients, { called, loading, data }] = useLazyQuery(
    GET_ALL_TECH_GROUP,
    {
      client: AccountClient,
      fetchPolicy: 'network-only'
    }
  );

  useEffect(() => {
    if (fetchBefore) {
      getClients();
    }
  }, [fetchBefore]);

  useEffect(() => {
    if (data?.getTechnicianGroups) {
      let clients = cloneDeep(data?.getTechnicianGroups);
      for (let i = 0; i < clients.length; i++) {
        clients[i].label = clients[i].name;
        clients[i].value = clients[i].name;
      }
      setoptions(clients);
    }
  }, [data]);

  useEffect(() => {
    setErrors(props.errors);
  }, [props.errors]);

  const onChangeField = (field) => {
    let obj = null;
    if (field) {
      obj = {};
      obj[property] = field[property];
      if (field?.name) {
        obj.name = field.name;
      }
    }
    updateField(value, obj);
  };

  useEffect(() => {
    setErrors(props.errors);
  }, [props.errors]);

  const constructDropDownError = () => {
    if (errors) {
      return reactSelectInlineError(errors);
    }
    return null;
  };
  const selectedOption =
    options.find((el) => el?.groupId === selectedValue?.groupId) || null;
  return (
    <SelectWrapper>
      {showLabel && (
        <div className="Polaris-Label">
          <label
            id="clientSelect"
            htmlFor="clientSelect"
            className="Polaris-Label__Text"
          >
            <FormattedMessage id="app.clientSelect.label" />
          </label>
        </div>
      )}
      <div className="fx center select-container">
        {!hideIcon &&
          (icon ? (
            <SVGIcon name="TechnicianGroup" />
          ) : (
            <Avatar
              name="client"
              source={`${envConfig.imageRoot}svg/client_white.svg`}
            />
          ))}

        <div className="container">
          {fetchBefore && loading ? (
            <Spinner
              accessibilityLabel="Small spinner example"
              size="small"
              color="inkLightest"
            />
          ) : (
            <>
              <Select
                className={``}
                key={selectedOption?.id}
                onMenuOpen={() => {
                  if (!fetchBefore) getClients();
                }}
                classNamePrefix="value_selector"
                formatGroupLabel={formatGroupLabel}
                defaultValue={defaultValue}
                value={selectedOption}
                components={{ IndicatorSeparator, DropdownArrow }}
                onChange={onChangeField}
                options={options}
                placeholder={getTranslatedText(
                  intl,
                  'app.techGroupDropdown.placeholder'
                )}
                menuPortalTarget={document.body}
                menuPlacement="auto"
                closeMenuOnScroll={(e) => {
                  return (
                    e.target &&
                    e.target.classList &&
                    !(e.target.classList.value.indexOf('menu-list') > -1)
                  );
                }}
                name="valueselector"
                styles={
                  props?.errors
                    ? {
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({ ...base, zIndex: 9999 }),
                        ...reactSelectErrorStyles
                      }
                    : {
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({ ...base, zIndex: 9999 })
                      }
                }
                noOptionsMessage={() => {
                  return loading ? 'Loading...' : 'No options';
                }}
                isClearable={isClearable}
                isDisabled={disabled}
              />
              {constructDropDownError()}
            </>
          )}
        </div>
      </div>
    </SelectWrapper>
  );
}

export default injectIntl(TechGroupSelect);
